const appSubmissionStatus = {
    inDevelopment: 'InDevelopment',
    submitted: 'Submitted',
    approved: 'Approved',
    live: 'Live',
};

export default appSubmissionStatus;
